import React from 'react';
import { TextInput, useTranslate, required } from 'react-admin';
import AceEditorInput from '~/components/ra/AceEditorInput';

const ScriptForm: React.FC = () => {
  const translate = useTranslate();
  const t = (key: string): string => translate(`resources.scripts.fields.${key}`);

  return (
    <>
      <TextInput source='extensionPoint' label={t('extensionPoint')} fullWidth disabled />
      <TextInput source='description' label={t('description')} fullWidth disabled multiline />
      <AceEditorInput
        source='data'
        label={t('script')}
        placeholder={t('scriptPlaceholder')}
        validate={[required()]}
      />
      <TextInput source='message' label={t('message')} fullWidth />
    </>
  );
};

export default ScriptForm;
